import UserRepository from '../../repositories/UserRepository';
import { LOGIN, LOGIN_FAILED, LOGOUT } from '../constants/auth-action-types';

export const login = (data) => {
    return async (dispatch) => {
        try {
            const result = await UserRepository.login(data);
            if (result.data.success) {
                dispatch({
                    type: LOGIN,
                    payload: result.data.data,
                });
            } else {
                dispatch({
                    type: LOGIN_FAILED,
                    payload:
                        result.data.message === 'LOGIN.VERIFICATION_ERROR' ||
                        result.data.message === 'LOGIN.ACCOUNT_DELETED'
                            ? result.data.message
                            : result.data.data,
                });
            }
        } catch (e) {
            console.log(e.response);
            dispatch({
                type: LOGIN_FAILED,
                payload:
                    e.response.status === 401
                        ? 'The email or password you entered is incorrect. Please try again.'
                        : 'Something is wrong',
            });
        }
    };
};

export const logout = () => {
    return async (dispatch) => {
        localStorage.removeItem('userData');
        dispatch({ type: LOGOUT });
    };
};
